// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import type { IconProps } from '@tls/treact-ui/icons';
import React from 'react';

const IconUndefined = ({ id, width, height, viewBox, strokeWidth, stroke, fill, ...other }: IconProps) => {
  return (
    <svg
      id={id ?? 'svg-undefined'}
      data-name='svg-undefined'
      data-testid='svg-undefined'
      xmlns='http://www.w3.org/2000/svg'
      width={width ?? '30'}
      height={height ?? '30'}
      viewBox={viewBox ?? '0 0 30 30'}
      strokeWidth={strokeWidth ?? '0'}
      stroke={stroke ?? 'currentColor'}
      fill={fill ?? 'currentColor'}
      {...other}
    >
      <circle cx='15' cy='15' r='11' fill='#707070' stroke='#707070' strokeWidth='3' />
      <rect x='8.75' y='13.125' width='12.5' height='3.75' fill='white' />
    </svg>
  );
};

export default IconUndefined;
